/**
 * host
 */

export default {
    domain: 'https://merchants.anlaiye.com',
    bip: 'https://bip.anlaiye.com',
    oc: 'https://oc.anlaiye.com.cn',
    imgsvc: 'https://imgsvc.anlaiye.com',
    payment: 'https://payment.anlaiye.com'
}




// WEBPACK FOOTER //
// ./vue/config/host-online.js